module.exports = "<div #portlet [ngClass]=\"class\" class=\"kt-portlet\">\n  <ng-content></ng-content>\n</div>\n"